var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtiqueta3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 808.88 514.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a58c70;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.83,166.33h-5.22v72.79h-57.42V37.28h61.77c53.95,0,78.31,22.33,78.31,63.8,0,20.59-6.67,41.76-27.55,54.23l39.44,83.81h-60.33l-29-72.79ZM435.61,127.76h5.22c14.79,0,19.43-8.41,19.43-26.68,0-17.11-6.67-24.65-20.3-24.65h-4.35v51.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640.36,77.01h-51.91v40.31h45.82v38.86h-45.82v42.63h55.39v40.31h-112.81V37.28h115.14l-5.8,39.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.52,137.33c0,80.62-38,101.79-87.58,101.79h-61.2V37.28h58.87c46.69,0,89.91,13.92,89.91,100.06ZM713.16,77.59v120.94h6.96c19.14,0,25.81-13.92,25.81-61.19s-7.25-59.74-24.94-59.74h-7.83Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.5,290.76l-23.78,29c-11.02-9.86-21.75-15.37-33.06-15.37s-16.53,6.67-16.53,15.95c0,9.86,6.38,14.21,28.13,24.36,33.35,15.66,49.01,30.16,49.01,66.12,0,39.15-27.55,66.12-73.09,66.12-34.22,0-55.1-13.92-70.18-29.87l26.68-29.87c12.76,11.31,24.65,18.56,38.57,18.56s18.56-8.99,18.56-19.72c0-11.89-6.38-19.14-24.36-27.26-39.44-17.69-52.49-34.51-52.49-63.22,0-38.57,29.58-62.06,68.15-62.06,28.13,0,48.14,9.86,64.38,27.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.32,369.93c0,70.47-27.55,107.02-80.05,107.02s-79.76-35.38-79.76-107.02,27.27-106.44,79.76-106.44,80.05,34.8,80.05,106.44ZM209.98,369.93c0,50.75,4.35,66.41,20.3,66.41s20.59-15.66,20.59-66.41-4.93-65.54-20.59-65.54-20.3,16.53-20.3,65.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.52,286.99l-25.81,30.74c-8.12-7.25-16.24-12.76-26.39-12.76-17.98,0-26.68,17.69-26.68,64.67s8.99,64.09,26.39,64.09c11.6,0,19.14-5.8,29.87-14.5l24.36,30.16c-13.34,14.5-33.35,27.55-60.04,27.55-47.27,0-80.05-34.22-80.05-107.31s33.35-106.14,81.21-106.14c23.78,0,42.34,8.99,57.13,23.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.37,471.15h-57.42v-201.85h57.42v201.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.71,431.12h-35.09l-5.8,40.02h-57.13l46.98-201.85h67.86l46.7,201.85h-57.71l-5.8-40.02ZM618.91,391.1l-11.89-81.49-11.6,81.49h23.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747.98,427.07h60.9l-5.8,44.08h-112.53v-201.85h57.42v157.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtiqueta3);
export default __webpack_public_path__ + "static/media/etiqueta3.60991c440f7a1b586fc6cddddc7bf789.svg";
export { ForwardRef as ReactComponent };